import { useQuery } from 'react-query';
import axios from 'axios';
import { INDEX_PAGE } from './useInvoices'; // item 1480 — whole index, not a 100-row page
import { WorkOrdersDto } from '../models/workOrder';

export const getWorkOrders = async (): Promise<WorkOrdersDto> => {
  const apiUrl = process.env.REACT_APP_BASIX_API || '';
  const { data } = await axios.get(`${apiUrl}WorkOrder/Search`, { params: { pageSize: INDEX_PAGE } });
  return data;
};

const useWorkOrders = () => useQuery('workOrders', getWorkOrders);

export default useWorkOrders;
